import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '../scss/app.scss';

// libraries



// utilities
import './dispatcher';
import {OutLiner, isTouch} from 'a-utils';
new OutLiner();


// import GlobalStore from './store/store';
// console.log(GlobalStore)

// components
import './analytic/analytic';

import './resize/resize.view';

import './masonry/masonry.component';
import './share/share.component';
import './creeping/creeping-line.component';
import './video/video-view.component';

import './links/anchor-view.component';
import './links/morf-link.component';

import './scroll/scroll-to';
import './scroll/scroll-animation';
import './scroll/fixed-arrow.component';

import './popup/popup-view.component';
import './popup/popup-button.component';
import './popup/popup-button.component';



if (isTouch()) document.body.classList.add('touch')

// modules
// import resizeView from './resize/resize.view';

// const init = () => {
//   // resizeView.init();
// }
//
//
//
// if (document.readyState !== 'loading') {
//   init();
// } else {
//   document.addEventListener('DOMContentLoaded', init);
// }
